import React, { useEffect } from 'react'
import './scrollup.css'
import { HiOutlineArrowSmUp } from 'react-icons/hi'

const ScrollUp = ({ scrollToSection }) => {
  useEffect(() => {
    const handleScroll = () => {
      const scrollUp = document.querySelector('.scrollup')
      if (window.scrollY >= 560) {
        scrollUp.classList.add('show-scroll')
      } else {
        scrollUp.classList.remove('show-scroll')
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <a
      href="/"
      className="scrollup"
      onClick={(e) => scrollToSection('/', 'home', e)}
    >
      <HiOutlineArrowSmUp className="scrollup__icon" />
    </a>
  )
}

export default ScrollUp
